(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["reviews-slider"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('reviews-slider')) return;

    class ReviewsSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        if (!this.viewport || !this.track) return;

        this.cards = Array.from(this.track.querySelectorAll('[data-card]'));
        if (!this.cards.length) return;

        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.dotsWrap = this.querySelector('[data-dots]');
        this.pauseBtn = this.querySelector('[data-pause]');

        const d = this.dataset;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Users who asked the OS for less motion get the manual slider instead.
        this.mode = reduceMotion ? 'manual' : d.mode || 'manual';
        this.dataset.activeMode = this.mode;
        this.loop = d.loop === 'true' || this.mode === 'autoplay';
        this.interval = Math.max(2, parseFloat(d.interval) || 5) * 1000;
        this.speed = parseFloat(d.speed) || 40;
        this.moveDir = d.direction === 'right' ? -1 : 1;
        this.pauseOnHover = d.pauseOnHover !== 'false';

        this.index = Math.min(this.index || 0, this.cards.length - 1);
        this.pos = this.pos || 0;
        this.nudge = 0;
        this.period = 0;
        this.lastWidth = null;
        this.reasons = new Set();

        if (this.pauseBtn && this.mode === 'manual') this.pauseBtn.hidden = true;

        this.ac = new AbortController();
        const o = { signal: this.ac.signal };

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1), o);
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1), o);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', () => this.setPaused('user', !this.reasons.has('user')), o);
        }

        if (this.pauseOnHover) {
          this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.setPaused('hover', true); }, o);
          this.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.setPaused('hover', false); }, o);
        }

        // Keyboard focus pauses; a mouse click on an arrow does not.
        this.addEventListener('focusin', (e) => {
          let keyboard = true;
          try { keyboard = e.target.matches(':focus-visible'); } catch (_) {}
          if (keyboard) this.setPaused('focus', true);
        }, o);
        this.addEventListener('focusout', (e) => {
          if (!this.contains(e.relatedTarget)) this.setPaused('focus', false);
        }, o);

        document.addEventListener('visibilitychange', () => this.setPaused('hidden', document.hidden), o);

        // Theme editor: hold still while the block is selected.
        const isMe = (e) => e.target === this || this.contains(e.target) || (e.target && e.target.contains && e.target.contains(this));
        document.addEventListener('shopify:block:select', (e) => { if (isMe(e)) this.setPaused('editor', true); }, o);
        document.addEventListener('shopify:block:deselect', (e) => { if (isMe(e)) this.setPaused('editor', false); }, o);

        this.bindPointer(o);

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.setPaused('offscreen', !entries[entries.length - 1].isIntersecting);
          });
          this.io.observe(this);
        }

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.layout());
          this.ro.observe(this.viewport);
        } else {
          window.addEventListener('resize', () => this.layout(), o);
        }

        this.layout();
        this.onStateChange();
      }

      disconnectedCallback() {
        if (this.ac) this.ac.abort();
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = null;
        clearTimeout(this.timer);
      }

      /* ---------- shared helpers ---------- */

      gap() {
        return parseFloat(getComputedStyle(this.track).columnGap) || 0;
      }

      perView() {
        return parseInt(getComputedStyle(this).getPropertyValue('--rs-per-view'), 10) || 1;
      }

      maxIndex() {
        return Math.max(0, this.cards.length - this.perView());
      }

      isPaused() {
        return this.reasons.size > 0;
      }

      setPaused(reason, on) {
        if (on === this.reasons.has(reason)) return;
        if (on) this.reasons.add(reason);
        else this.reasons.delete(reason);
        this.onStateChange();
      }

      onStateChange() {
        if (this.pauseBtn) {
          const userPaused = this.reasons.has('user');
          this.pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
          this.pauseBtn.setAttribute('aria-label', userPaused ? 'Abspielen' : 'Pausieren');
        }
        if (this.mode === 'marquee') this.updateLoop();
        else this.schedule();
      }

      layout() {
        const width = this.viewport.clientWidth;
        if (width === this.lastWidth) return;
        this.lastWidth = width;

        if (this.mode === 'marquee') {
          this.buildMarquee();
          this.render();
        } else {
          this.buildDots();
          this.goTo(this.index, false);
          this.schedule();
        }
      }

      step(delta) {
        if (this.mode === 'marquee') {
          this.nudge += delta * (this.cards[0].offsetWidth + this.gap());
          return;
        }
        this.goTo(this.index + delta);
        this.schedule();
      }

      bindPointer(o) {
        const vp = this.viewport;

        vp.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          this.drag = { id: e.pointerId, x: e.clientX, pos: this.pos, moved: false };
          if (this.mode === 'marquee') {
            this.nudge = 0;
            this.setPaused('drag', true);
          }
        }, o);

        vp.addEventListener('pointermove', (e) => {
          if (!this.drag || e.pointerId !== this.drag.id) return;
          const dx = e.clientX - this.drag.x;
          if (!this.drag.moved && Math.abs(dx) > 5) {
            this.drag.moved = true;
            vp.classList.add('is-dragging');
            try { vp.setPointerCapture(e.pointerId); } catch (_) {}
          }
          if (this.mode === 'marquee' && this.drag.moved) {
            this.pos = this.drag.pos - dx;
            this.render();
          }
        }, o);

        const end = (e) => {
          if (!this.drag || e.pointerId !== this.drag.id) return;
          const dx = e.clientX - this.drag.x;
          if (this.mode !== 'marquee' && e.type === 'pointerup' && Math.abs(dx) > 40) {
            this.step(dx < 0 ? 1 : -1);
          }
          this.drag = null;
          vp.classList.remove('is-dragging');
          if (this.mode === 'marquee') this.setPaused('drag', false);
        };
        vp.addEventListener('pointerup', end, o);
        vp.addEventListener('pointercancel', end, o);
      }

      /* ---------- slide modes (manual / autoplay) ---------- */

      buildDots() {
        if (!this.dotsWrap) return;
        const count = this.maxIndex() + 1;
        this.dotsWrap.hidden = count <= 1;
        if (this.dots && this.dots.length === count) return;

        this.dotsWrap.innerHTML = '';
        this.dots = [];
        for (let n = 0; n < count; n++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'reviews-slider__dot';
          dot.setAttribute('aria-label', 'Gehe zu Rezension ' + (n + 1));
          dot.addEventListener('click', () => {
            this.goTo(n);
            this.schedule();
          });
          this.dotsWrap.appendChild(dot);
          this.dots.push(dot);
        }
      }

      goTo(target, animate = true) {
        const max = this.maxIndex();
        let i = target;
        if (i > max) i = this.loop ? 0 : max;
        if (i < 0) i = this.loop ? max : 0;
        this.index = i;

        const offset = this.cards[i].offsetLeft - this.cards[0].offsetLeft;
        if (!animate) this.track.style.transition = 'none';
        this.track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
        if (!animate) {
          void this.track.offsetWidth;
          this.track.style.transition = '';
        }

        const per = this.perView();
        this.cards.forEach((card, n) => {
          card.setAttribute('aria-hidden', n < i || n >= i + per ? 'true' : 'false');
        });

        if (this.prevBtn) this.prevBtn.disabled = !this.loop && i === 0;
        if (this.nextBtn) this.nextBtn.disabled = !this.loop && i === max;
        this.classList.toggle('is-static', max === 0);

        if (this.dots) {
          this.dots.forEach((dot, n) => {
            dot.classList.toggle('is-active', n === i);
            if (n === i) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }

      schedule() {
        clearTimeout(this.timer);
        if (this.mode !== 'autoplay' || this.isPaused() || this.maxIndex() === 0) return;
        this.timer = setTimeout(() => {
          this.goTo(this.index + 1);
          this.schedule();
        }, this.interval);
      }

      /* ---------- continuous mode (marquee) ---------- */

      buildMarquee() {
        this.track.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());

        const first = this.cards[0];
        const last = this.cards[this.cards.length - 1];
        this.period = last.offsetLeft + last.offsetWidth + this.gap() - first.offsetLeft;
        if (this.period <= 0) return;

        // Enough copies that the track never shows a gap, whatever the screen width.
        const copies = Math.ceil(this.viewport.clientWidth / this.period) + 1;
        const frag = document.createDocumentFragment();
        for (let c = 0; c < copies; c++) {
          this.cards.forEach((card) => {
            const clone = card.cloneNode(true);
            clone.removeAttribute('data-card');
            clone.removeAttribute('role');
            clone.removeAttribute('aria-roledescription');
            clone.removeAttribute('aria-label');
            clone.setAttribute('data-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.inert = true;
            frag.appendChild(clone);
          });
        }
        this.track.appendChild(frag);
      }

      updateLoop() {
        const run = !this.reasons.has('offscreen') && !this.reasons.has('hidden');
        if (run && !this.raf) {
          this.lastTime = 0;
          this.raf = requestAnimationFrame((t) => this.tick(t));
        } else if (!run && this.raf) {
          cancelAnimationFrame(this.raf);
          this.raf = null;
        }
      }

      tick(now) {
        const dt = this.lastTime ? Math.min((now - this.lastTime) / 1000, 0.05) : 0;
        this.lastTime = now;

        if (!this.isPaused()) this.pos += this.speed * this.moveDir * dt;

        // Arrow clicks glide one card further, eased, on top of the constant drift.
        if (this.nudge) {
          const s = this.nudge * Math.min(1, dt * 8);
          this.pos += s;
          this.nudge -= s;
          if (Math.abs(this.nudge) < 0.5) {
            this.pos += this.nudge;
            this.nudge = 0;
          }
        }

        this.render();
        this.raf = requestAnimationFrame((t) => this.tick(t));
      }

      render() {
        if (this.mode !== 'marquee') return;
        if (this.period > 0) this.pos = ((this.pos % this.period) + this.period) % this.period;
        this.track.style.transform = 'translate3d(' + (-this.pos).toFixed(2) + 'px, 0, 0)';
      }
    }

    customElements.define('reviews-slider', ReviewsSlider);
  })();
  } catch(e) { console.error(e); }
})();

})();
